import React from 'react'

import { VariableProduct } from '~/types'


interface PropsType {
  children: (props: StateType) => React.ReactNode
  basePrice: VariableProduct['basePrice']
  coefficient: VariableProduct['coefficient']
}

interface StateType {
  mhs: number
  price: number
  updateMhs: typeof VariableProductState.prototype.updateMhs
}

export class VariableProductState extends React.Component<PropsType> {
  state: StateType = {
    mhs: 0,
    price: 0,
    updateMhs: this.updateMhs.bind(this),
  }

  updateMhs(mhs: number) {
    this.setState({
      mhs,
      price: calculateTotalPrice(this.props.basePrice, this.props.coefficient, mhs),
    })
  }

  render() {
    return this.props.children(this.state)
  }
}

export function calculateTotalPrice(basePrice: number, nextPricePercent: number, totalMHs: number): number {
  if (totalMHs === 1) return basePrice
  const price = basePrice * nextPricePercent
  return price + calculateTotalPrice(price, nextPricePercent, totalMHs - 1)
}



// WEBPACK FOOTER //
// ./src/pages/LandingPage/VariableProductState.tsx